export * from './SliderNewsItem';
